export default __webpack_public_path__ + "static/media/darkNftCard.06cecb2a.png";